<template>
  <v-container fluid>
    <CfsisTable class="pb-4">
      <template v-slot:actions="{ dataset }">
        <avs-exportButton
          :data="dataset"
          :prepare="preFmtData"
          :name="$t('actions.export_')"
          :spantext="$t('actions.export', { entity: $tc('categories.cfsi.name', 2) })"
        />
        <avs-createButton
          :to="{ name: 'CfsiCreateUpdate' }"
          :spantext="
            $t('actions.create', {
              entity: $tc('categories.cfsi.name', 1).toLowerCase()
            })
          "
          :name="
            $t('actions.new_female', {
              entity: $tc('categories.cfsi.name', 1).toLowerCase()
            })
          "
        />
      </template>
    </CfsisTable>
  </v-container>
</template>
<script>
import { CfsisTable } from "@/components"
import { fmtCfsiData } from "@/utils/download"

export default {
  name: "CfsisView",
  components: { CfsisTable },
  methods: {
    preFmtData(dataset) {
      return fmtCfsiData(dataset)
    }
  }
}
</script>
